module.exports = __webpack_public_path__ + "static/media/dismissed.55faef89.svg";